/**
 * `/pano-split` — standalone side-by-side photo ⇄ depth panorama inspector.
 *
 * Reads the stations.json URL from the `stations` query param (URL-encoded)
 * and an optional `station` query param, then renders <PanoramaSplitView />.
 * The heavy Three.js component is lazy-loaded so the route (and the router
 * module) stays out of the jsdom test bundle until actually opened.
 */

import { Suspense, lazy } from 'react';
import { useSearchParams } from 'react-router-dom';

const PanoramaSplitView = lazy(() =>
  import('@/engines/panorama-bubble/PanoramaSplitView').then((m) => ({
    default: m.PanoramaSplitView,
  })),
);

const DEFAULT_STATIONS_URL = '/converter-output/Job_080_119.bubble/stations.json';

export function PanoramaSplitRoute() {
  const [searchParams] = useSearchParams();
  const stationsUrl = searchParams.get('stations') ?? DEFAULT_STATIONS_URL;
  const initialStationId = searchParams.get('station') ?? undefined;

  return (
    <div style={{ width: '100vw', height: '100vh' }} data-route="/pano-split">
      <Suspense fallback={null}>
        <PanoramaSplitView stationsUrl={stationsUrl} initialStationId={initialStationId} />
      </Suspense>
    </div>
  );
}
